import { useNavigate } from 'react-router-dom';

import { paths } from '../routes/paths';

export const useCompanyNavigation = () => {
  const navigate = useNavigate();

  const handleValidate = (companyId: number) => {
    navigate(`${paths.validation}?companyId=${companyId}`);
  };

  const handleValidateV2 = (companyId: number, track: 'company' | 'crawl', crId?: number) => {
    const params = new URLSearchParams({ companyId: String(companyId), track });
    if (crId) params.set('crId', String(crId));
    navigate(`${paths.validationV2}?${params.toString()}`);
  };

  const handleNavigateToAssesment = (companyId: number) => {
    navigate(`${paths.evaluation.dfm}?companyId=${companyId}`);
  };

  return { handleValidate, handleValidateV2, handleNavigateToAssesment };
};
